// react =>
import { RefObject } from "react";

function isFieldEmpty(ref: RefObject<HTMLInputElement | null>): boolean {
    if (!ref.current?.value.trim()) {
        ref.current!.style.backgroundColor = "red";
        return true;
    }
    return false;
}

export function ValidateRequiredFields(
    onError: (message: string) => void,
    ...refs: RefObject<HTMLInputElement | null>[]
): boolean {
    const emptyFields = refs.filter(isFieldEmpty);
    
    if (emptyFields.length > 0) {
        onError("لطفاً تمام فیلدهای اجباری را پر کنید");
        return false;
    }
    
    return true;
}
